import React, { useEffect, useMemo, useRef, useState } from 'react';
import { ScheduleMessageType, SecureScheduleMessageType } from '../../models/conversations/schedule-messages.model';
import { Divider, TextField, Tooltip, makeStyles } from '@mui/material';
import moment from 'moment';
import Calendar from 'react-calendar';
import { UtilityService } from '../../services/UtilityService';
import { InformationDarkScheduleIcon } from '../../icon';
import ButtonComponent from '../shared/button/button.component';
import { useSelector } from 'react-redux';
import * as selector from '../../selectors/selectors'
interface Iprops {
    onSave: (scheduleDateTime: number, selectedScheduleType: number) => void;
    onClose: () => void;
    selectedScheduleType: number;
    scheduleDateTime: number;
    IsMobileDevice: boolean;
    IsSecureChat?: boolean;
}
const ScheduleMsgMobileComponent = (props: Iprops) => {
    const IsDarkMode: boolean = useSelector(selector.isDarkMode)
    const [scheduleDateTime, setScheduleDateTime] = useState<number>(props.scheduleDateTime === -1 ? UtilityService.roundTimeToMinutes(new Date().getTime(), 10) : props.scheduleDateTime);
    const [selectedScheduleType, setSelectedScheduleType] = useState<number>(props.selectedScheduleType ? props.selectedScheduleType : 0);
    const [isTimeVisible, setIsTimeVisible] = useState<boolean>(false);
    const [value, setValue] = React.useState(UtilityService.convertToPreferredTimeZone(scheduleDateTime) > UtilityService.getPreferredTimeZoneTimeNow() ? UtilityService.convertToPreferredTimeZone(scheduleDateTime) : UtilityService.getPreferredTimeZoneTimeNow());
    const minuteStep = 10;
    // Generate time options with 10-minute intervals
    const [timeOptions, setTimeOptions] = useState([]);
    const [selectedTime, setSelectedTime] = useState(new Intl.DateTimeFormat('en-US', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    }).format(props.scheduleDateTime === -1 ? UtilityService.roundTimeToMinutes(new Date().getTime(), 10) : new Date(props.scheduleDateTime)));
    const selectedTimeRef = useRef(null); // Create a ref for the selected time element
    const calendarRef = useRef(null);// Create a ref for the selected calendar element

    let ScheduleTypes = props.IsSecureChat ?
        [
            { Name: "One time", Value: SecureScheduleMessageType.ONE_TIME }
            , { Name: "Daily", Value: SecureScheduleMessageType.DAILY }
            , { Name: "Weekly", Value: SecureScheduleMessageType.WEEKLY }
            , { Name: "Monthly", Value: SecureScheduleMessageType.MONTHLY }
        ]
        : [
            { Name: "One time", Value: ScheduleMessageType.ONE_TIME }
            , { Name: "Daily", Value: ScheduleMessageType.DAILY }
            , { Name: "Weekly", Value: ScheduleMessageType.WEEKLY }
            , { Name: "Every 2 weeks", Value: ScheduleMessageType.EVERY_2_WEEKS }
            , { Name: "Monthly", Value: ScheduleMessageType.MONTHLY }
            , { Name: "Every 6 months", Value: ScheduleMessageType.EVERY_6_MONTHS }
            , { Name: "Every year", Value: ScheduleMessageType.EVERY_YEAR }
        ];

    const onChange = (date: any) => {
        let fDate = UtilityService.convertToDateFormat(date);
        let fTime = UtilityService.convertToTimeFormat(value);
        let x = UtilityService.convertToDateTimeFormat(`${fDate} ${fTime}`)
        setValue(new Date(x));
        setScheduleDateTime(UtilityService.roundTimeToMinutes(new Date(x).getTime(), minuteStep));
    }

    const handleTimeClick = (time: any) => {
        setSelectedTime(time)
        const newDate = value;
        const [hours, minutes] = time.split(':');
        newDate.setHours(hours);
        newDate.setMinutes(minutes);
        setValue(newDate)
        setScheduleDateTime(UtilityService.roundTimeToMinutes(newDate.getTime(), minuteStep))
    }

    const trimTimeZone = (timeZoneName: any, maxLength: number) => {
        return !!timeZoneName ? timeZoneName.slice(0, maxLength) + (timeZoneName.length > maxLength ? "..." : "") : "";
    }

    useMemo(() => {
        const timeOptionsL = []
        for (let hour = 0; hour < 24; hour++) {
            for (let minute = 0; minute < 60; minute += 10) {
                const time = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
                timeOptionsL.push(time);
            }
        }
        setTimeOptions(timeOptionsL)
    }, [])

    useEffect(() => {
        if (selectedTimeRef.current) {
            selectedTimeRef.current.scrollIntoView({ behavior: "smooth", block: "center" });
        }

    }, [selectedTime]);

    useEffect(() => {
        if (!isTimeVisible) return; // Early exit if the calendar is not visible

        const handleClickOutside = (event) => {
            if (calendarRef.current && !calendarRef.current.contains(event.target)) {
                setIsTimeVisible(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isTimeVisible]);

    // const useStyles = makeStyles({
    //     root: {
    //         "& label.Mui-focused": {
    //             color: "#1738F3"
    //         },
    //         "& .MuiOutlinedInput-root": {
    //             "&.Mui-focused fieldset": {
    //                 borderColor: "#1738F3"
    //             }
    //         }
    //     }
    // });
    // const classes = useStyles();
    return (
        <div className='d-flex flex-direction ml-1 h-v-62 o-y-scroll' style={IsDarkMode ? {} : { background: "#F8F8F8" }} >
            <p className='mobile-schedule-title mb-1 ml-1'>Schedule your message</p>
            <div className='schedule-option-view-mobile justify-item-center align-center'>
                {
                    ScheduleTypes.map((ele) => {
                        return <div onClick={() => setSelectedScheduleType(ele.Value)} className={`d-flex flex-direction-row justify-center mb-1 px-1 py-1 ${selectedScheduleType === ele.Value ?
                            "schedule-type-btn-selected" : "schedule-type-btn-unselected"}`}>
                            <span style={{ color: selectedScheduleType === ele.Value ? "white" : IsDarkMode ? "white" : "black" }}>{ele.Name}</span>
                        </div>
                    })
                }
            </div>
            <div className='d-flex flex-direction-row mr-2 mt-2'>
                <TextField
                    size="small"
                    fullWidth
                    id="input-with-icon-textfield"
                    onClick={() => {
                        setIsTimeVisible(true);
                    }}
                    aria-readonly={true}
                    // className={`${classes.root} mx-1 br-1 mt-1 mobile-schedule-time`}
                    className={`mx-1 br-1 mt-1 mobile-schedule-time`}
                    tabIndex={17}
                    value={
                        scheduleDateTime === -1 ? "MM DD YYYY" : moment(scheduleDateTime).format(`MMMM Do YYYY`)}
                    inputProps={{ style: { fontSize: 12, font: "normal normal normal 12px silkaregular" } }}
                    variant="outlined"
                />
                <TextField
                    size="small"
                    fullWidth
                    aria-readonly={true}
                    id="input-with-icon-textfield"
                    // className={`${classes.root} br-1 mt-1 mobile-schedule-time`}
                    className={`br-1 mt-1 mobile-schedule-time`}
                    onClick={() => {
                        setIsTimeVisible(false);
                    }}
                    tabIndex={17}
                    value={
                        scheduleDateTime === -1 ? "HH:mm" : moment(scheduleDateTime).format(`HH:mm`)}
                    inputProps={{ style: { fontSize: 12, font: "normal normal normal 12px silkaregular" } }}
                    variant="outlined"
                />
            </div >

            <div style={{ display: isTimeVisible ? "none" : "block", height: "230px" }} className={`mt-2 mx-2 o-y-scroll o-x-hidden`}>
                {
                    timeOptions.map((e) => {
                        return <div ref={e === selectedTime ? selectedTimeRef : null} onClick={() => handleTimeClick(e)} className={`py-1 mb-1 mt-1 mx-2 w-p-90 d-flex flex-direction justify-center align-center`} style={IsDarkMode ? { height: "15px", background: e === selectedTime ? "#111826" : "#1f2a38" } : { height: "15px", background: e === selectedTime ? "#e3e3e3" : "white" }}>
                            <span style={IsDarkMode ? { fontSize: "11.5px", color: "white" } : { fontSize: "11.5px", color: "black" }} className='py-2 pb-1'>{e}</span>
                            <Divider />
                        </div>
                    })
                }
            </div>
            {isTimeVisible && <div className="calender-root mr-2 ml-2 mt-2">
                <div ref={calendarRef} style={IsDarkMode ? {} : { background: "white" }} className='d-flex flex-direction-row align-center pt-2 pb-2 justify-around'>
                    <Calendar
                        onClickDay={onChange}
                        className="react-calendar-height"
                        value={value}
                        minDate={UtilityService.getPreferredTimeZoneTimeNow()}
                    />
                </div>
                <div className="pb-1 pl-1 d-flex flex-direction-row justify-center">
                    <div className="">
                        Account time zone: {trimTimeZone(UtilityService.getPreferedTimeZone().Name, 15)} ({UtilityService.getPreferedTimeZone().OffsetLabel})
                    </div>
                    <Tooltip title={"By default Scheduled messages are sent based on your account time zone."} placement="top-start"  >
                        <InformationDarkScheduleIcon className="pl-1" />
                    </Tooltip>
                </div>
            </div>}
            <div className='d-flex flex-direction-row mr-2 ml-2 justify-center my-1'>
                <ButtonComponent ButtonLabel={"save"} ClassName={`mr-2 ${props.IsMobileDevice ? "w-p-80 mx-auto" : "w-p-100"}`} Variant={"primary-btn"} OnClick={() => { props.onSave(scheduleDateTime, selectedScheduleType) }}></ButtonComponent>
                <ButtonComponent ButtonLabel={" cancel"} ClassName={`${props.IsMobileDevice ? "w-p-80 mx-auto" : "w-p-100"}`} Variant={"secondary-btn"} OnClick={() => { props.onClose() }}></ButtonComponent>
            </div>
        </div>
    );
}

export default ScheduleMsgMobileComponent;